export { renderColorSwatch_unstable as renderColorSwatch } from '@fluentui/react-swatch-picker';
